import React from 'react';
import PropTypes from 'prop-types';

import timer from '../../config/timer.config';
import { ABreadCrumb } from '../atoms';
import { MIndicators } from '../molecules';

export default class MHeroImageSlider extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			index: 0,
			prevIndex: props.items.length - 1,
		};

		this.bindHandles();
		this.timeOut = undefined;
	}

	componentDidMount() {
		this.startSlider();
	}

	componentWillUnmount() {
		clearTimeout(this.timeOut);
	}

	bindHandles() {
		this.handleBack = this.handleBack.bind(this);
		this.handleBackKeyDown = this.handleBackKeyDown.bind(this);
		this.handleNext = this.handleNext.bind(this);
		this.handleNextKeyDown = this.handleNextKeyDown.bind(this);
		this.goToNext = this.goToNext.bind(this);
	}

	handleBack() {
		if (this.props.items.length < 2) {
			return;
		}

		this.setState(prev => ({
			index: prev.index - 1 === -1 ? this.props.items.length - 1 : prev.index - 1,
			prevIndex: prev.index - 1 === -1 ? 0 : prev.index,
		}));

		clearTimeout(this.state.timeOut);
		this.startSlider();
	}

	handleBackKeyDown(event) {
		if (event.keyCode === 13) {
			this.handleBack();
		}
	}

	handleNext() {
		if (this.props.items.length < 2) {
			return;
		}

		this.setState(prev => ({
			index: prev.index + 1 === this.props.items.length ? 0 : prev.index + 1,
			prevIndex: prev.index + 1 === this.props.items.length ? this.props.items.length - 1 : prev.index,
		}));

		clearTimeout(this.timeOut);
		this.startSlider();
	}

	handleNextKeyDown(event) {
		if (event.keyCode === 13) {
			this.handleNext();
		}
	}

	goToNext() {
		this.setState(prev => ({
			index: prev.index + 1 === this.props.items.length ? 0 : prev.index + 1,
			prevIndex: prev.index + 1 === this.props.items.length ? this.props.items.length - 1 : prev.index,
		}));
	}

	startSlider() {
		if (this.props.items.length < 2) {
			return;
		}

		this.timeOut = setTimeout(() => this.handleNext(), timer.slider);
	}

	render() {
		let breadCrumb;

		if (this.props.currentPage) {
			breadCrumb = (
				<div className="breadCrumb">
					<ABreadCrumb
						currentPage={this.props.currentPage}
						parents={this.props.parents}
					/>
				</div>
			);
		}

		return (
			<section className={`m-hero ${this.props.className}`}>
				<article className="m-hero--slider">
					{
						this.props.items.map((item, index) => (
							<img
								src={item}
								alt=""
								key={item}
								className={`m-hero--slider-img
									${this.state.prevIndex === index ? 'previous' : ''}
									${this.state.index === index ? 'active' : ''}
								`}
							/>
						))
					}
				</article>
				<button
					className="m-hero--slider-clickable-area"
					onClick={this.handleBack}
					onKeyUp={this.handleBackKeyDown}
				/>
				<button
					className="m-hero--slider-clickable-area right"
					onClick={this.handleNext}
					onKeyUp={this.handleNextKeyDown}
				/>
				<MIndicators
					amount={this.props.items.length}
					value={this.state.index}
					className="m-hero--slider-indicators"
				/>
				{this.props.children}
				{breadCrumb}
			</section>
		);
	}
}

MHeroImageSlider.propTypes = {
	items: PropTypes.array.isRequired,
	className: PropTypes.string,
	currentPage: PropTypes.any.isRequired,
	parents: PropTypes.any,
};

MHeroImageSlider.defaultProps = {
	className: '',
	currentPage: undefined,
	parents: undefined,
};




// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.hero-image-slider.js